module.exports = __webpack_public_path__ + "img/left1.c24f93c8.png";